import packageInfo from "../../package.json";

// Get the correct server url depending on environment
function getServerURL(
  environment: "development" | "production" | "test"
): string {
  switch (environment) {
    case "production":
      // return "https://api-cached.intelligentlilli.com";
      return process.env.REACT_APP_API_URL;
    // return "https://api-supertokens.prod.aws.intelligentlilli.com";
    case "test":
      return "http://localtest.me:8044";
    case "development":
      // return "https://worker-dev.intelligentlilli.com";
      // return "https://api-supertokens.dev.aws.intelligentlilli.com";
      return process.env.REACT_APP_API_URL;
    default:
      console.error("Environment not an expected value!" + environment);
      /// assume dev as a fallback
      return "http://localtest.me:8044";
  }
}

function getSupertokenServerURL(
  environment: "development" | "production" | "test"
) {
  switch (environment) {
    case "production":
      // return "https://auth.prod.aws.intelligentlilli.com";
      return process.env.REACT_APP_AUTH_API_URL;
    case "development":
      // return "https://auth.dev.aws.intelligentlilli.com";
      return process.env.REACT_APP_AUTH_API_URL;
    default:
      return process.env.REACT_APP_AUTH_API_URL;
    // return "https://auth.prod.aws.intelligentlilli.com";
  }
}
  
export const SUPERTOKEN_SERVER = getSupertokenServerURL(process.env.NODE_ENV);

export const SERVER = getServerURL(process.env.NODE_ENV);

export const CLIENT_VERSION = packageInfo.version;

export const mobileBreakpoint = 600;

export const reportsBreakpoint = 800;

export const tabletBreakpoint = 900;

export const widescreenBreakpoint = 1200;
